module.exports = __webpack_public_path__ + "img/MutaGenE32A00BE136A41C0034A_-min.3663797a.png";